import React from "react";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routesWrapper from "routes.js";
import routes from "routes.js";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  
  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );


  }, [])


  React.useEffect(() => {
    getActiveRoute();
  }, [location.pathname]);


  // A path matches when it's an exact match, or (for routes that accept a
  // trailing param, e.g. GREAT's /great/:direction) when the pathname starts
  // with the route path followed by a "/".
  const pathMatches = (routePath) =>
    location.pathname === routePath ||
    (routePath !== "/" && location.pathname.startsWith(routePath + "/"));

  const getActiveRoute = () => {
    let activeRoute = "";

    for (let i = 0; i < routes.length; i++) {
      const routePath = "/" + routes[i].path;
      if (pathMatches(routePath)) {
        setCurrentRoute(routes[i].name);
        return;
      }
    }

    setCurrentRoute(activeRoute);
  };


  const getActiveNavbar = () => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      const routePath = "/" + routes[i].path;
      if (pathMatches(routePath)) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };


  const getRoutes = () => {
    const filteredRoutes = routesWrapper();
    return filteredRoutes.flatMap((prop, key) => {
      const base = `/${prop.path}`;
      const elements = [
        <Route path={base} element={prop.component} key={key} />,
      ];
      // GREAT Analytics supports an optional direction segment
      // (/great/outbound, or /outbound when it's the supervisor index route).
      if (prop.name === "GREAT Analytics") {
        const paramPath = prop.path ? `/${prop.path}/:direction` : `/:direction`;
        elements.push(
          <Route path={paramPath} element={prop.component} key={`${key}-direction`} />
        );
      }
      return elements;
    });
  };

  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />

      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">

        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr- ${open ? "xl:ml-60" : "xl:ml-0"}`}
        >

          <div className="h-full">
            <Navbar
                onOpenSidenav={() => setOpen(prev => !prev)}
              logoText={"Gabriel & Co"}
              brandText={currentRoute}
              secondary={getActiveNavbar()}
              {...rest}
            />

            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
